import React from 'react';
import { SupportSummaryPayload } from '../../types/chat';

interface SupportSummaryCardProps {
    summary: SupportSummaryPayload;
}

const SupportSummaryCard: React.FC<SupportSummaryCardProps> = ({ summary }) => {
    return (
        <div className="rounded-2xl border border-brand-200 bg-brand-50 p-5 text-sm text-brand-900">
            <h3 className="text-base font-semibold text-brand-800">Thanks! Here's what we'll share with support:</h3>
            <div className="mt-3 space-y-3">
                {summary.items?.length ? (
                    <ul className="space-y-2">
                        {summary.items.map((item, idx) => (
                            <li key={idx} className="flex items-start space-x-2">
                                <span className="mt-0.5 h-2 w-2 rounded-full bg-brand-400" aria-hidden />
                                <span>
                                    <span className="font-medium text-brand-800">{item.label}:</span> {item.value}
                                </span>
                            </li>
                        ))}
                    </ul>
                ) : null}

                {summary.details && (
                    <div>
                        <p className="text-xs font-semibold uppercase tracking-wide text-brand-700">Additional details</p>
                        <p className="mt-1 whitespace-pre-line text-sm text-brand-900">{summary.details}</p>
                    </div>
                )}

                {summary.contact && Object.keys(summary.contact).length > 0 && (
                    <div className="rounded-lg border border-brand-200 bg-white p-3">
                        <p className="text-xs font-semibold uppercase tracking-wide text-brand-700">Contact</p>
                        <div className="mt-2 space-y-1 text-sm text-brand-900">
                            {summary.contact.name && <p><span className="font-medium">Name:</span> {summary.contact.name}</p>}
                            {summary.contact.email && <p><span className="font-medium">Email:</span> {summary.contact.email}</p>}
                            {summary.contact.phone && <p><span className="font-medium">Phone:</span> {summary.contact.phone}</p>}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SupportSummaryCard;
